export default __webpack_public_path__ + "static/media/scleton2.b4a74f35.jpg";